import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface SettingItem {
  upi_id: string;
  account_number: string;
  bank_name: string;
  ifsc_code: string;
  account_holder_name: string;
  qr_img: string; // This will store the image URL or path from the server
  isactive: boolean;
  payment_type: string; // Assuming this is a string, adjust if it's different
}

const BankUpiEdit = () => {
  const [settings, setSettings] = useState<SettingItem>({
    upi_id: '',
    account_number: '',
    bank_name: '',
    ifsc_code: '',
    account_holder_name: '',
    qr_img: '',
    isactive: false,
    payment_type: 'bank'
  });
  const [qrFile, setQrFile] = useState<File | null>(null); // To store the uploaded file


  // Handle text input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  // Handle file input change base64
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];
      setQrFile(file); // Set the file to state

      // Convert file to Base64 for preview
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setSettings((prevSettings) => ({
          ...prevSettings,
          qr_img: reader.result as string, // Store Base64 preview in state
        }));
      };
    }
  }

  


    async function fetchSetting() {
    try {
      const token = localStorage.getItem("token"); // Retrieve token from localStorage

      const response = await axios.get(
        `https://api.trubetx.com/admin/getBankDetailsSettingsById?id=${window.location.pathname.split('/').pop()}&payment_type=bank`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add Authorization header
          },
        }
      );

      if (response?.data?.data) {
        setSettings(response.data.data); // Ensure correct data structure
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  }

  useEffect(() => {
    fetchSetting();
  }, []);
  
  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Create FormData to send both text data and file
    const formData = new FormData();
    formData.append('upi_id', settings?.upi_id);
    formData.append('account_number', settings?.account_number);
    formData.append('bank_name', settings?.bank_name);
    formData.append('ifsc_code', settings?.ifsc_code);
    formData.append('account_holder_name', settings?.account_holder_name);
    formData.append('isactive', settings?.isactive ? 'true' : 'false');
    formData.append('payment_type', 'bank'); // Assuming payment_type is always 'bank'
    if( qrFile ) {
      formData.append('qr_img', qrFile); // Append the file directly
    }

    try {
      const response = await axios.post(
        `https://api.trubetx.com/admin/updateBankDetailsSettingsById/${window.location.pathname.split('/').pop()}`,
        {
          upi_id: settings.upi_id,
          account_number: settings.account_number,
          bank_name: settings.bank_name,
          ifsc_code: settings.ifsc_code,
          account_holder_name: settings.account_holder_name,
          qr_img: settings.qr_img, // Send Base64 string as JSON
          isactive: settings.isactive ? 'true' : 'false',
          payment_type: 'bank', // Send payment_type
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setSettings((prevSettings) => ({
        ...prevSettings,
        qr_img: response?.data.qr_img, // Update with new image path from the server response
      }));
      alert('Settings updated successfully!');
      
    } catch (error) {
      console.error("Error updating settings:", error);
      alert('Failed to update settings.');
    }
  };

  return (
    <main className="flex ml-0 lg:ml-[230px]  overflow-auto bg-stone-100 pb-8">
    <div className="w-full flex-1 px-5">
      <div className="my-5">
        <div className="flex items-center justify-between">
          <div className="w-auto">
            <h1 className="font mb-3 flex flex-wrap items-center text-lg font-bold text-stone-800 md:text-xl">
              Add Bank Details{" "}
            </h1>
          </div>
          <div className="w-auto" />
        </div>
        <div className="flex items-center gap-2">
          <a className="font-semibold text-cm-gray" href="/web/banking/create#">
            Banking<span className="ml-2">/</span>
          </a>
          <a className="font-semibold text-cm-gray" href="/web/banking/create#">
            Add Details
          </a>
        </div>
      </div>
       <section className="overflow-auto ">
        <form onSubmit={handleSubmit} className="shagow-lg relative rounded-lg bg-white py-1">
          <div className="grid gap-5 rounded-lg  p-5 sm:grid-cols-2">
           
            <div>
              <label className="text-gray-800">Account Number</label>
              <input
                type='text'
                name='account_number'
                value={settings?.account_number}
                onChange={handleChange}
                className='border rounded p-2 w-full'
              />
            </div>
            <div>
              <label className="text-gray-800">Bank Name</label>
              <input
                type='text'
                name='bank_name'
                value={settings?.bank_name}
                onChange={handleChange}
                className='border rounded p-2 w-full'
              />
            </div>
            <div>
              <label className="text-gray-800">IFSC Code</label>
              <input
                type='text'
                name='ifsc_code'
                value={settings?.ifsc_code}
                onChange={handleChange}
                className='border rounded p-2 w-full'
              />
            </div>
            <div>
              <label className="text-gray-800">Account Holder Name</label>
              <input
                type='text'
                name='account_holder_name'
                value={settings?.account_holder_name}
                onChange={handleChange}
                className='border rounded p-2 w-full'
              />
            </div>
            <div>
              <label className="text-gray-800">UPI ID</label>
              <input
                type='text'
                name='upi_id'
                value={settings?.upi_id}
                onChange={handleChange}
                className='border rounded p-2 w-full'
              />
            </div>
            <div>
              <label className="text-gray-800">QR Image</label>
              <input
                type='file'
                name='qr_img'
                onChange={handleFileChange}
                className='border rounded p-2 w-full'
              />
            </div>

            {settings.qr_img && (
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={
                      settings.qr_img.startsWith("data:image")
                        ? settings.qr_img // Show selected image preview
                        : `https://api.trubetx.com/uploads/QrCodes/${settings.qr_img}`
                    } // Show stored image
                    alt="QR Code"
                    className="w-36 h-36 object-contain border p-2 border-gray-700 rounded-lg"
                  />
                </div>
              )}

              <div>
                <label
                htmlFor="hs-basic-usage"
                className="relative inline-block w-11 h-6 cursor-pointer"
              >
                <input
                    type="checkbox"
                    checked={settings?.isactive}
                    onChange={(e) =>
                      setSettings((prev) => ({
                        ...prev,
                        isactive: e.target.checked,
                      }))
                    }
                    id="hs-basic-usage"
                    className="peer sr-only"
                  />

                <span className="absolute inset-0 bg-gray-200 rounded-full transition-colors duration-200 ease-in-out peer-checked:bg-blue-600 dark:bg-neutral-700 dark:peer-checked:bg-blue-500 peer-disabled:opacity-50 peer-disabled:pointer-events-none" />
                <span className="absolute top-1/2 start-0.5 -translate-y-1/2 size-5 bg-white rounded-full shadow-xs transition-transform duration-200 ease-in-out peer-checked:translate-x-full dark:bg-neutral-400 dark:peer-checked:bg-white" />
              </label>

              </div>
            <div className="my-5 flex items-center justify-start gap-4">
              
              <button
                className="mantine-UnstyledButton-root mantine-Button-root rounded-lg mantine-1xk8bhn"
                type="submit"
                data-button="true"
              >
                <div className="bg-[#228be6] py-2 px-4 text-white rounded-lg mantine-Button-inner">
                  <span className="mantine-1ryt1ht mantine-Button-label">
                    Add Record
                  </span>
                </div>
              </button>
            </div>
          </div>
          </form>
        </section>
        
     
    </div>
    </main>
  );
};

export default BankUpiEdit;
